export default __webpack_public_path__ + "static/background-box2-6c8f4cabdfe2c217553d9fed0072008b.svg";